import coreCMS from 'assets/core/js/entry/cms'
import lastSeen from 'assets/core/js/module/last-seen'
import dataLayer from 'assets/core/js/page/search/data-layer'
import productFavorite from 'assets/core/js/page/search/product/favorite'
import searchForm from 'assets/themes/campings/js/module/searchForm'
import blocksToggle from 'assets/themes/campings/js/page/search/blocks-toggle'
import bookingReward from 'assets/themes/campings/js/page/search/booking-reward'
import budgetSlider from 'assets/themes/campings/js/page/search/budget-slider'
import crossBorder from 'assets/themes/campings/js/page/search/cross-border'
import filters from 'assets/themes/campings/js/page/search/filters'
import imagesSliders from 'assets/themes/campings/js/page/search/images-sliders'
import loading from 'assets/themes/campings/js/page/search/loading'
import map from 'assets/themes/campings/js/page/search/map'
import openProductPageLinks from 'assets/themes/campings/js/page/search/open-product-page-links'
import results from 'assets/themes/campings/js/page/search/results'
import sorting from 'assets/themes/campings/js/page/search/sorting'

document.addEventListener('DOMContentLoaded', function () {
  dataLayer()
  imagesSliders.init()

  budgetSlider()
  openProductPageLinks()
  sorting()
  blocksToggle()
  loading()
  filters()
  map()
  productFavorite()
  bookingReward()
  searchForm()

  coreCMS()
  results()
  lastSeen()
  crossBorder()
})
